'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTypingMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isTypingMessage = exports.isTypingMessage = (0, _isType.isType)(_messageTypes.TYPING);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isTypingMessage.js
// module id = 589
// module chunks = 2 3